var map = {
	"./arrow.svg": "9667",
	"./comment.svg": "a81c",
	"./facebook.svg": "93be",
	"./forward.svg": "8e23",
	"./instagram.svg": "d276",
	"./logo.svg": "8923",
	"./love.svg": "4ac1",
	"./menu.svg": "3896",
	"./thumb-up.svg": "86ca",
	"./tiktok.svg": "fee1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f6c";